import { render, staticRenderFns } from "./QuestionQuizFullPageFullScreen.vue?vue&type=template&id=3822dbb8&scoped=true"
import script from "./QuestionQuizFullPageFullScreen.vue?vue&type=script&lang=js"
export * from "./QuestionQuizFullPageFullScreen.vue?vue&type=script&lang=js"
import style0 from "./QuestionQuizFullPageFullScreen.vue?vue&type=style&index=0&id=3822dbb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3822dbb8",
  null
  
)

export default component.exports